import { useContext } from "react";
import { ControlContext } from "../ControlContext.jsx";
import ChangeDepths from "../Helpers/ChangeDepths.jsx";

import Glass from "./FrameComp/Glass";
import FloatProfile from "./FrameComp/FloatFrame/FloatProfile";
import Dibond from "./FrameComp/Dibond";

export default function FloatFrame({}) {
  const { floatFinishDepth } = useContext(ControlContext);

  const { printDepth, dibondDepth } = ChangeDepths();

  const renderGlass = () => {
    switch (floatFinishDepth) {
      case 0:
        return <></>;
      case 0.2:
        return (
          <>
            <Glass glassDepth={printDepth + 0.1} />
          </>
        );
    }
  };

  return (
    <>
      <FloatProfile />
      <Dibond depth={dibondDepth} />
      {renderGlass()}
    </>
  );
}
